// extracted by mini-css-extract-plugin
module.exports = {"emptyLabel":"fieldset_emptyLabel__3WuM6","fieldsetTitle":"fieldset_fieldsetTitle__3qMOQ"};